module.exports = __webpack_public_path__ + "static/media/CD-Bordes.4bb80fdc.jpg";